/* @ngInject */
export function nonNegative () {
	return function (val) {
		if (val <= 0) {
			return 0;
		}
		return val;
	};
}
